import a18n from 'a18n';
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import Stream from '../Stream';
import UserList from '../UserList';
import RoomIDInput from '../RoomIDInput';
import { getUrlParam } from '../../utils/utils';
import { getLanguage } from '../../utils/common';
import { Accordion, AccordionDetails, AccordionSummary, Button, Radio, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import '../../styles/common.scss';
import { withStyles } from '@material-ui/core/styles';
import Toast from '../Toast';
import DeviceSelect from '../DeviceSelect';
import { ENV_IS_PRODUCTION } from '../../utils/constants';
import ShareRTC from '../BaseRTC/ShareRTC';
import Client from '../RtcClient/basic-live-rtc-client';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { ANCHOR, AUDIENCE } from '../../config/tencent';
import { IconTypes, Popup } from '@tencentcloud/chat-uikit-react';
import share from '../LiveChat/image/share.png';
import stopLive from '../LiveChat/image/stop_live.png';
import stopIcon from '../LiveChat/image/Stop-button-open.png';
import stopCloseIcon from '../LiveChat/image/Stop-button-close.png';
import facebook from '../LiveChat/image/facebook.png';
import pinterest from '../LiveChat/image/pinterest.png';
import twitter from '../LiveChat/image/twitter.png';
import linkedin from '../LiveChat/image/linkedin.png';
import constant, { STORAGE_NAME } from '../../constants';
import { useMediaQuery } from 'react-responsive';
import { useLiveAtiveElements } from '../LiveChat/TUILive/hooks/useLiveAtiveElements';
import TRTC from "trtc-js-sdk";
import gifConfirmGift from "../LiveChat/image/confirm_gift.png";
import languages from '../../languages';

const mobile = require('is-mobile');
const DynamicRtc = Client;
const DynamicShareRtc: any = ShareRTC;

const BlueRadio = withStyles({
  root: {
    '&$checked': {
      color: '#006EFF',
    },
  },
  checked: {},
})((props) => <Radio color='default' {...props} />);

export default function LiveStream({ activeId, navConfig, setIsChatShow, setIsGiftShow, isShowAction, setIsShowAction, tim }: any) {
  const languageCurrent: string = a18n.getLocale() ?? 'ja';
  const isResponsive = useMediaQuery({ maxWidth: '768px' });
  const userID = useSelector((state: RootState) => state.userProfile.userID);
  const video = true;
  const audio = true;
  const mode = 'live';
  const [useStringRoomID, setUseStringRoomID] = useState(false);
  const [RTC, setRTC]: any = useState(null);
  const [shareRTC, setShareRTC]: any = useState(null);
  const [roomID, setRoomID] = useState('');
  const [cameraID, setCameraID] = useState('');
  const [indexCameraID, setIndexCameraID] = useState(0);
  const [microphoneID, setMicrophoneID] = useState('');
  const [localStreamConfig, setLocalStreamConfig]: any = useState(null);
  const [remoteStreamConfigList, setRemoteStreamConfigList]: any = useState([]);
  const [isJoined, setIsJoined]: any = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [userRole, setUserRole] = useState(AUDIENCE);
  const [mountFlag, setMountFlag] = useState(false);
  const [isShowSharePopup, setIsShowSharePopup] = useState<boolean>(false);
  const [linkData, setLinkData] = useState<string>();
  const [embedData, setEmbedData] = useState<string>();
  const [streamInfoData, setStreamInfoData] = useState<any>();
  const [showPopupCloseLive, setShowPopupCloseLive] = useState<boolean>(false);

  //  Stream share
  const searchParams = new URLSearchParams(document.location.search);
  const streamUrl = constant.apiUrl + '/?p=' + searchParams.get('roomId');
  const listShareItem = [
    {
      icon: facebook,
      link: 'https://www.facebook.com/sharer/sharer.php?u=' + streamUrl,
    },
    {
      icon: pinterest,
      link: 'https://pinterest.com/pin/create/button/?url=' + streamUrl,
    },
    {
      icon: twitter,
      link: 'https://twitter.com/intent/tweet?url=' + streamUrl,
    },
    {
      icon: linkedin,
      link: 'https://www.linkedin.com/shareArticle?mini=true&url=' + streamUrl,
    },
  ];

  useEffect(() => {
    const language = 'ja' || getLanguage();
    a18n.setLocale(language);
    setMountFlag(true);

    setUseStringRoomID(getUrlParam('useStringRoomID') === 'true');
    setIsMobile(mobile());
    getInfoShare();
  }, []);

  useEffect(() => {
    firstLoad();
  }, [RTC]);


  if (typeof window !== 'undefined') {
    const textarea: any = document.getElementsByTagName('textarea');
    if (textarea[0]) {
      textarea[0]?.setAttribute('placeholder', languages[languageCurrent]?.sendMessage)
    }
  }

  const handleSocial = (item: any) => {
    window.open(item.link, "popUpWindow", "height=" + screen.height / 2 + ",width=" + screen.width / 2 + ",resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes");
  }

  const getInfoShare = () => {
    fetch(
      constant.apiUrl +
      "/wp-json/stream/get-info?post_id=" +
      searchParams.get("roomId") +
      "&user_id=" +
      searchParams.get("userId")
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setLinkData(constant.apiUrl + "/?p=" + searchParams.get("roomId"));
          setEmbedData(
            '<iframe width="560" height="315" src="' +
            result.post_data.guid +
            'embed/" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"></iframe>'
          );
          localStorage.setItem(
            STORAGE_NAME.CURRENT_POST + searchParams.get("roomId"),
            JSON.stringify(result)
          );
          setStreamInfoData(result);
        },
        (error) => {
          console.log(error.message);
        }
      );
  }

  const handleShare = () => {
    setIsShowSharePopup(prev => !prev);
  }

  const handleStopLive = () => {
    setShowPopupCloseLive(!showPopupCloseLive);
  }
  const stopLiveAction = async () => {
    // Out Room live
    await handleLeave();
    // Out Room chat
    await tim.dismissGroup(`${roomID}`);
    // Call API close room BE
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-WP-Nonce", localStorage.getItem('nonce_api') || ``);
    Toast.info('Loading close live...', 200000);
    await fetch(`${constant.apiUrl}/wp-json/stream/close`, {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({ roomID }),
      redirect: 'follow',
    }).then(response => response.text())
      .then((res: any) => {
        console.log(res);
        // Redirect
        window.location.href = `${constant.apiUrl}`;
      }).catch((e: any) => {
        Toast.error(e, 2000);
        console.log('error close room:', e);
      })
  }

  const firstLoad = async () => {
    const roleCurrent = getUrlParam('role') || userRole;
    const roomID = getUrlParam('roomID');

    // Auto join room
    if (!isJoined && RTC && (roleCurrent === ANCHOR || (roleCurrent === AUDIENCE && roomID))) {
      setUserRole(roleCurrent);
      RTC.role = roleCurrent;
      await handleJoin();

      if (roleCurrent === ANCHOR) {
        await handlePublish();
      }
    }
  }

  const handleJoin = async () => {
    await RTC.handleJoin();
  };

  const handlePublish = async () => {
    // if (userRole === audience) {
    //   toast.error('please change to Anchor', 2000);
    //   return;
    // }
    await RTC.handlePublish();
  };

  const handleUnPublish = async () => {
    await RTC.handleUnPublish();
    await RTC.destroyLocalStream();
  };

  const handleLeave = async () => {
    shareRTC && shareRTC.handleLeave();
    await RTC.handleLeave();
    setShowPopupCloseLive(false);
  };

  const changeRole = async () => {
    if (!RTC.isJoined) {
      Toast.error('please join room!', 2000);
      return;
    }
    if (RTC.isPublished || RTC.isPublishing) {
      Toast.error('please change role in unpublish ', 2000);
      return;
    }
    try {
      const targetRole = userRole === AUDIENCE ? ANCHOR : AUDIENCE;
      await RTC.client.switchRole(targetRole);
      RTC.role = targetRole;
      setUserRole(targetRole);
    } catch (error) {
      console.log('basic live change role error = ', error);
    }
  };

  const setState = (type: string, value: boolean) => {
    switch (type) {
      case 'join':
        setIsJoined(value);
        break;
      case 'publish':
        setIsPublished(value);
        break;
      default:
        break;
    }
  };

  // 新增用户
  const addUser = (userID: string, streamType: any) => {
    if (streamType === 'local') {
      setLocalStreamConfig({
        stream: null,
        streamType,
        userID,
        hasAudio: false,
        hasVideo: false,
        mutedAudio: false,
        mutedVideo: false,
        shareDesk: false,
        audioVolume: 0,
        width: 320,
        height: 640
      });
    } else {
      setRemoteStreamConfigList((preList: any) => {
        const newRemoteStreamConfigList: any = preList.length > 0
          ? preList.filter((streamConfig: any) => streamConfig.userID !== userID)
          : [];
        newRemoteStreamConfigList
          .push({
            stream: null,
            streamType: 'main',
            userID,
            hasAudio: false,
            hasVideo: false,
            mutedAudio: false,
            mutedVideo: false,
            subscribedAudio: false,
            subscribedVideo: false,
            resumeFlag: false,
            audioVolume: 0,
            width: 320,
            height: 640
          });
        return newRemoteStreamConfigList;
      });
    }
  };

  // 增加流
  const addStream = (stream: any) => {
    const streamType = stream.getType();
    const userID = stream.getUserId();
    switch (streamType) {
      case 'local':
        setLocalStreamConfig({
          stream,
          streamType,
          userID,
          hasAudio: audio,
          hasVideo: video,
          mutedAudio: false,
          mutedVideo: false,
          shareDesk: false,
          audioVolume: 0,
        });
        break;
      default: {
        setRemoteStreamConfigList((preList: any) => {
          const newRemoteStreamConfigList: any = preList.length > 0
            ? preList.filter((streamConfig: any) => !(streamConfig.userID === userID
              && streamConfig.streamType === streamType))
            : [];
          newRemoteStreamConfigList
            .push({
              stream,
              streamType,
              userID,
              hasAudio: stream.hasAudio(),
              hasVideo: stream.hasVideo(),
              mutedAudio: false,
              mutedVideo: false,
              subscribedAudio: false,
              subscribedVideo: true,
              resumeFlag: false,
              audioVolume: 0,
            });
          return newRemoteStreamConfigList;
        });
        break;
      }
    }
  };

  // 更新流数据
  const updateStream = (stream: any) => {
    if (stream.getType() === 'local') {
      setLocalStreamConfig({
        ...localStreamConfig,
        stream,
        hasAudio: stream.hasAudio(),
        hasVideo: stream.hasVideo(),
      });
    } else {
      setRemoteStreamConfigList((preList: any) => preList.map((config: any) => (
        config.stream === stream ? {
          ...config,
          stream,
          hasAudio: stream.hasAudio(),
          hasVideo: stream.hasVideo(),
        } : config
      )));
    }
  };

  // 更新对本地流和远端流的操作状态
  const updateStreamConfig = (userID: string, type: string, value: number) => {
    // 更新本地流配置
    if (localStreamConfig && localStreamConfig.userID === userID) {
      const config: any = {};
      switch (type) {
        case 'audio-volume':
          if (localStreamConfig.audioVolume === value) {
            break;
          }
          config.audioVolume = value;
          break;
        case 'share-desk':
          config.shareDesk = value;
          break;
        case 'uplink-network-quality':
          config.uplinkNetworkQuality = value > 0 ? 6 - value : value;
          break;
        case 'downlink-network-quality':
          config.downlinkNetworkQuality = value > 0 ? 6 - value : value;
          break;
        default:
          break;
      }
      setLocalStreamConfig((prevConfig: any) => ({
        ...prevConfig,
        ...config,
      }));
      return;
    }
    // 更新远端流配置
    const config: any = {};
    switch (type) {
      case 'mute-audio':
        config.mutedAudio = true;
        break;
      case 'unmute-audio':
        config.mutedAudio = false;
        break;
      case 'mute-video':
        config.mutedVideo = true;
        break;
      case 'unmute-video':
        config.mutedVideo = false;
        break;
      case 'resume-stream':
        config.resumeFlag = true;
        break;
      case 'audio-volume':
        if (config.audioVolume === value) {
          break;
        }
        config.audioVolume = value;
        break;
      default:
        break;
    }
    setRemoteStreamConfigList((preList: any) => preList.map((item: any) => (
      item.userID === userID ? { ...item, ...config } : item
    )));
  };

  // 移除流
  const removeStream = (stream: any) => {
    const streamType = stream && stream.getType();
    const userID = stream && stream.getUserId();
    switch (streamType) {
      case 'local':
        setLocalStreamConfig((prevConfig: any) => ({
          ...prevConfig,
          hasAudio: false,
          hasVideo: false,
        }));
        break;
      default: {
        setRemoteStreamConfigList((preList: any) => preList
          .map((streamConfig: any) => (streamConfig.userID === userID && streamConfig.streamType === streamType
            ? {
              ...streamConfig,
              hasAudio: false,
              hasVideo: false,
              subscribedAudio: false,
              subscribedVideo: false,
            } : streamConfig)));
        break;
      }
    }
  };

  // 移除用户
  const removeUser = (userID: string, streamType: string) => {
    if (streamType === 'local') {
      setLocalStreamConfig(null);
      setRemoteStreamConfigList([]);
    } else {
      setRemoteStreamConfigList((preList: any) => preList.filter((streamConfig: any) => streamConfig.userID !== userID));
    }
  };

  // 处理本地流 streamBar 的响应逻辑
  const handleLocalChange = async (data: any) => {
    switch (data.name) {
      case 'video':
        if (!localStreamConfig.mutedVideo) {
          RTC.muteVideo();
        } else {
          RTC.unmuteVideo();
        }
        setLocalStreamConfig({
          ...localStreamConfig,
          mutedVideo: !localStreamConfig.mutedVideo,
        });
        break;
      case 'audio':
        if (!localStreamConfig.mutedAudio) {
          RTC.muteAudio();
        } else {
          RTC.unmuteAudio();
        }
        setLocalStreamConfig({
          ...localStreamConfig,
          mutedAudio: !localStreamConfig.mutedAudio,
        });
        break;
      case 'shareDesk':
        if (!localStreamConfig.shareDesk) {
          await shareRTC.handleJoin();
        } else {
          await shareRTC.handleLeave();
        }
        setLocalStreamConfig({
          ...localStreamConfig,
          shareDesk: !localStreamConfig.shareDesk,
        });
        break;
      default:
        break;
    }
  };

  const handleRemoteChange = async (data: any) => {
    const remoteStream = data.stream;
    const config = remoteStreamConfigList.find((config: any) => config.stream === remoteStream);
    switch (data.name) {
      case 'subscribedVideo':
        await RTC.handleSubscribe(remoteStream, {
          video: !config.subscribedVideo,
          audio: config.subscribedAudio,
        });

        setRemoteStreamConfigList((preList: any) => preList.map((config: any) => (
          config.stream === remoteStream ? ({
            ...config,
            subscribedVideo: !config.subscribedVideo,
          }) : config
        )));
        break;
      case 'subscribedAudio':
        await RTC.handleSubscribe(remoteStream, {
          video: config.subscribedVideo,
          audio: !config.subscribedAudio,
        });
        setRemoteStreamConfigList((preList: any) => preList.map((config: any) => (
          config.stream === remoteStream ? ({
            ...config,
            subscribedAudio: !config.subscribedAudio,
          }) : config
        )));
        break;
      case 'resumeFlag':
        await RTC.resumeStream(config.stream);
        setRemoteStreamConfigList((preList: any) => preList.map((config: any) => (
          config.stream === remoteStream ? ({
            ...config,
            resumeFlag: !config.resumeFlag,
          }) : config
        )));
        break;
      default:
        break;
    }
  };

  const handleChangeCamera = async () => {
    const listCamera = await TRTC.getCameras();
    const indexCurrentCamera = listCamera.map((item: any) => item.deviceId).indexOf(cameraID) || 0;

    if (!listCamera.length) {
      return false;
    }

    if (indexCurrentCamera + 1 < listCamera.length) {
      let cameraNext = indexCurrentCamera + 1
      setIndexCameraID(cameraNext);
      setCameraID(listCamera[cameraNext].deviceId);
    } else {
      setIndexCameraID(0);
      setCameraID(listCamera[0].deviceId);
    }

  }

  // @ts-ignore
  const pageContent = () => (
    <div className={clsx('content-container', isMobile && 'mobile-device')}>
      {/* Player */}
      <div className={'stream-container'}>
        {/* 本地流 */}
        {
          localStreamConfig && (localStreamConfig.hasAudio || localStreamConfig.hasVideo)
          && <Stream
            userRole={userRole}
            handleChangeCamera={handleChangeCamera}
            stream={localStreamConfig.stream}
            config={localStreamConfig}
            init={(dom: any) => RTC.playStream(localStreamConfig.stream, dom)}
            onChange={(e: any) => handleLocalChange(e)}></Stream>
        }
        {/* 远端流 */}
        {
          remoteStreamConfigList.length > 0
          && remoteStreamConfigList.map((remoteStreamConfig: any) => {
            if (remoteStreamConfig.hasAudio || remoteStreamConfig.hasVideo) {
              return (
                <Stream
                  userRole={userRole}
                  key={`${remoteStreamConfig.stream.getUserId()}_${remoteStreamConfig.stream.getType()}`}
                  stream={remoteStreamConfig.stream}
                  config={remoteStreamConfig}
                  init={(dom: any) =>
                    RTC.playStream(remoteStreamConfig.stream, dom)
                  }
                  onChange={(e: any) => handleRemoteChange(e)}
                ></Stream>
              );
            }
            return null;
          })
        }
      </div>
      {/* Option */}
      <div className={clsx('control-container', isMobile && 'mobile-device')} style={{ display: 'none' }}>
        <div className={clsx('body-container', isMobile && 'mobile-device')}>
          <Accordion className={'accordion-container'} defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              classes={{
                root: 'accordion-summary-container',
                content: 'accordion-summary-content',
              }}
            >
              {mountFlag && <Typography>{a18n('操作')}</Typography>}
            </AccordionSummary>
            <AccordionDetails className={'accordion-details-container'}>
              {/*@ts-ignore*/}
              <RoomIDInput disabled={isJoined} onChange={value => setRoomID(value)}></RoomIDInput>

              {userRole === ANCHOR && (<>
                <DeviceSelect deviceType="camera" onChange={value => setCameraID(value)}></DeviceSelect>
                <DeviceSelect deviceType="microphone" onChange={value => setMicrophoneID(value)}></DeviceSelect>
              </>)}

              <div className={clsx('button-container', isMobile && 'mobile-device')}>
                <Button id="join" variant="contained" color="primary" className={isJoined ? 'forbidden' : ''} onClick={handleJoin}>JOIN</Button>
                <Button id="leave" variant="contained" color="primary" onClick={handleLeave}>LEAVE</Button>
                <Button id="publish" variant="contained" color="primary" className={isPublished ? 'forbidden' : ''} onClick={handlePublish}>PUBLISH</Button>
                <Button id="unpublish" variant="contained" color="primary" onClick={handleUnPublish}>UNPUBLISH</Button>
              </div>
            </AccordionDetails>
          </Accordion>
          {/* 用户列表 */}
          <div className={clsx('user-list-container')}>
            <UserList localStreamConfig={localStreamConfig} remoteStreamConfigList={remoteStreamConfigList}>
            </UserList>
          </div>
        </div>
        {/* 生成二维码 */}
        {
          !isMobile && ENV_IS_PRODUCTION
          && <div className={clsx('footer-container')}>
            {mountFlag && <Typography>{a18n('移动端体验')}</Typography>}
          </div>
        }
      </div>
    </div>
  );

  const likeStream = searchParams.get('role') != ANCHOR && useLiveAtiveElements({
    icon: IconTypes.UNUNION,
    activeIcon: IconTypes.UNION,
    name: '',
    iconWidth: 22,
    iconHeight: 22,
    key: 'LiveHeart',
    value: streamInfoData?.like_follow_data?.is_liked,
    className: 'button-like-stream',
  });




  return (
    <div className={clsx('page-container', isMobile && 'mobile-device')} onClick={() => setIsShowAction(false)}>
      {
        userID
        && roomID
        && <DynamicRtc
          onRef={(ref: any) => setRTC(ref)}
          userID={userID}
          roomID={roomID}
          useStringRoomID={useStringRoomID}
          cameraID={cameraID}
          microphoneID={microphoneID}
          audio={audio}
          video={video}
          mode={mode}
          setState={setState}
          addUser={addUser}
          removeUser={removeUser}
          addStream={addStream}
          updateStream={updateStream}
          updateStreamConfig={updateStreamConfig}
          removeStream={removeStream}
          role={userRole}
        ></DynamicRtc>
      }
      {
        localStreamConfig
        && <DynamicShareRtc
          onRef={(ref: any) => setShareRTC(ref)}
          userID={`share_${userID}`}
          roomID={roomID}
          relatedUserID={userID}
          useStringRoomID={useStringRoomID}
          updateStreamConfig={updateStreamConfig}>
        </DynamicShareRtc>
      }
      {pageContent()}

      {!isResponsive && (
        <div className='like-share-area'>
          <span className='icon icon-tim'>{likeStream}</span>
          {searchParams.get('role') == ANCHOR && isPublished && <img className='icon icon-top-live' src={stopLive} width={44} height={44} onClick={handleStopLive} />}
          <img className='icon icon-share' src={share} onClick={handleShare} />
        </div>
      )}

      {isResponsive && isShowAction && (
        <div className='like-share-area'>
          <span className='icon icon-tim'>{likeStream}</span>
          {searchParams.get('role') == ANCHOR && <img className='icon icon-top-live' src={stopLive} width={44} height={44} onClick={handleStopLive} />}
          <img className='icon icon-share' src={share} onClick={handleShare} />
        </div>
      )}

      {isResponsive && (
        <div
          style={{
            bottom: '13px',
            position: 'fixed',
            right: '15px',
          }}
        >
          <img
            className='icon icon-stop'
            src={isShowAction ? stopIcon : stopCloseIcon}
            onClick={(e) => {
              e.stopPropagation();
              setIsShowAction(!isShowAction);
              setIsChatShow(false);
              setIsGiftShow(false);
            }}
          />
        </div>
      )}

      {/* Sharing Popup  */}
      <Popup className={`stream-share-popup`} show={isShowSharePopup}>
        <div className='stream-share-popup-area'>
          <div className='stream-share-popup-box'>
            <div className='stream-share-popup-header'>
              <header
                className='tui-gift-popup-header'
                style={{ padding: '10px 0', fontSize: '20px' }}
              >
                <h1 style={{ color: 'white', fontSize: '25px' }}>Share</h1>
                <i className='icon-close' onClick={handleShare}></i>
              </header>
              <div>
                <ul
                  className='tui-live-list'
                  style={{ marginBottom: '20px', justifyContent: 'center' }}
                >
                  {listShareItem?.map((item) => (
                    <li className='tui-live-item' key={item.icon}>
                      <img
                        className='gift-item-icon'
                        src={item.icon}
                        alt=''
                        width={50}
                        style={{
                          borderRadius: '5px',
                          cursor: 'pointer',
                          background: 'white',
                        }}
                        onClick={() => handleSocial(item)}
                      />
                    </li>
                  ))}
                </ul>
                <label>Link</label>
                <input type='text' className='link' value={linkData} />
                <br />
                <label>Embed</label>
                <textarea className='embed'>{embedData}</textarea>
              </div>
            </div>
          </div>
        </div>
      </Popup>

      {/* Close live Popup*/}
      <Popup
        className='popup-confirm-send-gift'
        show={showPopupCloseLive}
      >
        <div className='popup-confirm-send-gift-area'>
          <div className='popup-confirm-send-gift-box'>
            <div className='area-header'>
              <img className='icon-confirm' src={gifConfirmGift} alt="" />
              <div>
                <h1>{languages[languageCurrent]?.closeStreamPopupConfirmTitle}</h1>
                <p>{languages[languageCurrent]?.closeStreamPopupConfirmDescription}</p>
              </div>
            </div>
            <div className='area-content'>
              <button className='button-confirm-send-gift' onClick={stopLiveAction}>{languages[languageCurrent]?.buttonConfirm}</button>
              <button className={`${languageCurrent == 'ja' && 'button-cancel-send-gift-ja'}`} onClick={handleStopLive}><span>{languages[languageCurrent]?.buttonCancel}</span></button>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}
